'use strict';

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck;

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass;

var html = function html(tag) {
  return document.createElement(tag);
};
var getDomain = function getDomain(url) {
  var parser = html("a");
  parser.href = url;
  return parser.origin;
};

var Connection =
/*#__PURE__*/
function () {
  function Connection(frameRef, url, callback) {
    classCallCheck(this, Connection);

    this.active = true;
    this.frameRef = frameRef;
    this.targetWindow = frameRef.contentWindow;
    this.targetDomain = getDomain(url);
    this.recieveCallback = this.messageReceiverFactory(callback);
    window.addEventListener("message", this.recieveCallback);
  }

  createClass(Connection, [{
    key: "messageReceiverFactory",
    value: function messageReceiverFactory(callback) {
      var _this = this;

      return function (messageEvent) {
        if (_this.targetDomain === messageEvent.origin && messageEvent.data.bridgeContent) {
          callback(messageEvent.data.bridgeContent, _this);
        }
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      if (this.active) {
        this.targetWindow.postMessage({
          bridgeContent: data
        }, this.targetDomain);
      }
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      this.active = false;

      this.frameRef.onload = function () {};

      this.frameRef.src = "";
      window.removeEventListener("message", this.recieveCallback);
    }
  }]);

  return Connection;
}();

var connect = function connect(frameRef, url, callback) {
  var connection = new Connection(frameRef, url, callback);
  var connectionPromise = new Promise(function (resolve, reject) {
    frameRef.onload = function () {
      resolve(connection);
    };

    frameRef.onerror = function () {
      reject("Frame Timeout");
    };
  });
  frameRef.src = url;
  return connectionPromise;
};

var browser = {
  connect: connect
};

module.exports = browser;
